import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "no-key",
    authDomain: "buku-chat.firebaseapp.com",
    projectId: "buku-chat",
    storageBucket: "buku-chat.appspot.com",
    messagingSenderId: "244759125030",
    appId: "1:244759125030:web:7f8ebb9936a815367c5ae7",
    measurementId: "G-3YGGDWLB51"
};

// Initialize Firebase
initializeApp(firebaseConfig);
export const db = getFirestore();